import type { ButtonHTMLAttributes } from "react";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "primary" | "gold" | "ghost" | "danger";
  loading?: boolean;
}

export function Button({ variant = "default", loading = false, className = "", children, disabled, ...rest }: ButtonProps) {
  return (
    <button className={`btn ${variant} ${className}`} disabled={disabled || loading} aria-busy={loading || undefined} {...rest}>
      {loading ? <span className="spinner" aria-hidden /> : null}
      {children}
    </button>
  );
}
